import { render, staticRenderFns } from "./ParticipateCardGameValo.vue?vue&type=template&id=321dc364&scoped=true"
import script from "./ParticipateCardGameValo.vue?vue&type=script&lang=js"
export * from "./ParticipateCardGameValo.vue?vue&type=script&lang=js"
import style0 from "./ParticipateCardGameValo.vue?vue&type=style&index=0&id=321dc364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321dc364",
  null
  
)

export default component.exports